import { CrudOptions } from "components/Category/CrudMenu";

/**
 * Determines if the autoMenuActionsCode should be passed to Entity based on actionType match
 * @param actionType - The current action type (create, edit, view, etc.)
 * @param autoMenuActionsCode - The menu action code to evaluate
 * @returns The autoMenuActionsCode if it matches the actionType (case-insensitive), otherwise undefined
 */
export const getAutoMenuActionsCode = (
  actionType: string | undefined,
  autoMenuActionsCode: CrudOptions | undefined
): CrudOptions | undefined => {
  return actionType?.toLowerCase() === String(autoMenuActionsCode)?.toLowerCase()
    ? autoMenuActionsCode
    : undefined;
};
